import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET } from '../../../services/rest.service';

const ContactUsList = () => {
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);
  const [pages, setPages] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(-1);

  useEffect(() => {
    getPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPage = async (page) => {
    dispatch(showLoading());
    try {
      const { data } = await GET(`admin/contact/get/${page}`);
      setRecords(data.Contacts);
      setPages(data.Pages);
      setTotal(data.Total);
      setCurrentPage(page);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };
  const handlePageClick = (e) => {
    getPage(e.selected + 1);
  };

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className="text-uppercase mb-0">Contact Requests</h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table card-text">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Contacted On</th>
                        <th>Email</th>
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((record, index) => {
                        return (
                          <tr key={index}>
                            <th scope="row">{(currentPage - 1) * 20 + (index + 1)}</th>
                            <th>{record.created_at || record.createdAt ? moment(record.created_at || record.createdAt).format('MM/DD/YYYY hh:mm A') : '-'}</th>
                            <td>{record.email}</td>
                            <td>{record.name}</td>
                            <td>{record.phoneNumber}</td>
                            <td>{record.message}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto my-4">
            <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              pageClassName={'page-item'}
              onPageChange={handlePageClick}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUsList;
